import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGrades } from "../ApiService/ApiService";

export const fetchGradesAsync = createAsyncThunk(
  "grades/fetchGrades",
  async () => {
    const response = await getGrades();
    return response.data;
  }
);

const initialState = {
  grades: [],
  loading: false,
  error: null,
};

export const gradesSlice = createSlice({
  name: "grades",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGradesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGradesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.grades = action.payload.data;
      })
      .addCase(fetchGradesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllGrades = (state) => state.grades.grades;
export const selectGradesLoading = (state) => state.grades.loading;
export const selectGradesError = (state) => state.grades.error;

export default gradesSlice.reducer;
